import { render, staticRenderFns } from "./DlvD_Details.vue?vue&type=template&id=2c5d57be"
import script from "./DlvD_Details.vue?vue&type=script&lang=js"
export * from "./DlvD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports